import { useEffect } from 'react';
import { MarketingHeader, MarketingFooter } from '../components/MarketingChrome';
import { PrivacyPolicyContent, PRIVACY_POLICY_EFFECTIVE_DATE } from '@kangaroo/ui';
import '../components/landing.css';

const EFFECTIVE_DATE = PRIVACY_POLICY_EFFECTIVE_DATE;

export function PrivacyPage() {
  useEffect(() => {
    document.title = 'Privacy policy | Paddiq';
  }, []);
  return (
    <div className="landing marketing-home mh-interior">
      <a className="mh-skip" href="#main">
        Skip to content
      </a>
      <MarketingHeader />

      <main id="main">
        <section className="policy-hero">
          <div className="landing-container policy-hero__inner">
            <p className="section-kicker">Privacy Policy</p>
            <h1>Paddiq Privacy Policy</h1>
            <p className="policy-hero__lead">
              This policy explains what information Paddiq collects, why we use it, when it is
              shared, and the choices available to young drivers, parents, guardians, coaches,
              teams, and individual racers.
            </p>
            <p className="policy-hero__date">Effective {EFFECTIVE_DATE}</p>
          </div>
        </section>

        <section className="policy-section">
          <div className="landing-container policy-layout">
            <aside className="policy-summary" aria-label="Privacy summary">
              <h2>Quick summary</h2>
              <ul>
                <li>
                  We collect the account, driver, kart, telemetry, setup, billing, and support
                  information needed to provide Paddiq.
                </li>
                <li>
                  Telemetry files may contain GPS coordinates recorded by a racing data logger.
                  Paddiq does not use them to track a person outside a session.
                </li>
                <li>
                  We do not sell personal information or use it for third-party targeted
                  advertising.
                </li>
                <li>
                  Parents and guardians can ask us to review, correct, export, or delete information
                  associated with their child.
                </li>
                <li>
                  The iOS app uses local-network and file or photo access only when you choose
                  features that need them.
                </li>
              </ul>
            </aside>

            <div className="policy-documents">
              <PrivacyPolicyContent />
            </div>
          </div>
        </section>
      </main>

      <MarketingFooter />
    </div>
  );
}
